const types = {
    SET_AUTHORIZE: '[AUTH] SET AUTHORIZE',
    SET_ADMIN: '[AUTH] SET ADMIN'
}

export {
    types
}